import React,{useState,useEffect,}from 'react'
import { Table,Space, Flex,} from 'antd';
import Main from '../../cpn/Main';
import { useAppStationListQuery,  } from '../../store/ReactWebSiteApi';
import PostDel from './PostDel';
import PostAdd from './PostAdd';
import PostEdit from './PostEdit';
import {DeleteOutlined,LogoutOutlined} from '@ant-design/icons';
function PostList() {  
    const [query,setQuery] = useState({
            ess_e_id:localStorage.getItem('e_id'),
            ess_state:'2'
        })
    const {data,isSuccess} = useAppStationListQuery(query,)
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                const newArr = data.Result.map(item => {
                    const {ess_id:key,ess_name,num,ess_esv,ess_uname,ess_ctime,ess_update_ctime,ess_update_uname,ess_state} = item;
                    return item = {key,ess_name,num,ess_esv,ess_uname,ess_ctime,ess_update_ctime,ess_update_uname,ess_state}
                })
                // const filteredArray = newArr.filter(item => item.ess_role === '0');                                
                setList(newArr)
            }else{
                setList()
            }
        }
    }, [data, isSuccess])  
    const columns = [
        {
            key: 'type',
            title: '岗位',
            dataIndex:'ess_name',
        },
        {
            key: 'num',
            title: '用户数',
            dataIndex:'num',
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>                        
                        <PostEdit 
                            ess_id={record.key}
                            ess_state={record.ess_state}
                        />
                        <PostDel 
                            ess_id={record.key} 
                            num={record.num} 
                            ess_state={record.ess_state}
                        />                                          
                    </Space>
                </>
            }
        },
    ]
    
    return (
        <Main t1='岗位'>
            {query.ess_state==='2' ? <Flex justify='space-between' align='center'>
                                        <PostAdd />
                                        <a 
                                            style={{
                                                marginRight:"20px",
                                                fontSize:"18px"
                                            }}
                                            onClick={() => {
                                                setQuery(prevState=>({...prevState,ess_state:'1'}))
                                            }}
                                        ><DeleteOutlined /> 已删除岗位</a>
                                    </Flex>:<Flex>
                                                <a 
                                                    style={{
                                                        fontSize:"18px"
                                                        }}
                                                    onClick={() => {
                                                        setQuery(prevState=>({...prevState,ess_state:'2'}))
                                                    }}
                                                ><LogoutOutlined /> 未删除岗位</a>
                                            </Flex>}
            <Table 
                columns={columns} 
                dataSource={list}
                style={{
                    marginTop:"20px"
                }}
            ></Table> 
        </Main>
    )
}

export default PostList